import { Backdrop, CircularProgress } from '@mui/material'
import { useAppSelector } from '@/redux/hooks'
import { getMediaDetailsState } from '../slice'

export const MediaBackdrop = () => {
  const { isLoading } = useAppSelector(getMediaDetailsState).mediaDetailsState

  return (
    <Backdrop open={isLoading}>
      <CircularProgress />
    </Backdrop>
  )
}
